import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailer.service';

@Component({
  selector: 'app-delete-retailer',
  templateUrl: './delete-retailer.component.html',
  styleUrls: ['./delete-retailer.component.scss']
})
export class DeleteRetailerComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  iconClass: string = 'chevron-right';
  showMessageContainer: boolean = false;
  retailerName: string;
  isSendMessage: boolean = false;
  retailerInfo: any;
  message:string = '';
  constructor(public dialogRef: MatDialogRef<DeleteRetailerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private retailerService : RetailerService) {
    super();
   
      this.retailerInfo = data.retailerInfo;
      //this.data = data;
     }

  ngOnInit(): void {
    super.ngOnInit()
  }
  ngOnDestroy(){
    super.ngOnDestroy()
  }
  addMessage(){
    this.iconClass = this.iconClass == 'chevron-right' ? 'expand-more' : 'chevron-right';
    this.showMessageContainer = !this.showMessageContainer; 
  }

  checkMessage(){
    this.iconClass = this.iconClass == 'chevron-right' ? 'expand-more' : 'chevron-right';
    this.showMessageContainer = !this.showMessageContainer; 
  }
  

  onCloseRetailer(){
    let retailer_id: any = this.retailerInfo.retailerId;
    if (this.showMessageContainer){
     
    }
    this.retailerService.closeRetailerAccount(retailer_id, this.message, this.isSendMessage).subscribe(res => {
      if (res['httpcode'] == 200) {
        this.toastrService.success('Retailer account closed successfully!', 'Success')
        this.dialogRef.close()
      }
    })
  }

  onNotifyRetailer(){
    let amount: any = this.retailerInfo.currentAmount;
    let retailer_id: any = this.retailerInfo.retailerId;
    if (amount > 0){
      this.retailerService.notifyRetailer(amount, retailer_id).subscribe(res => {
        if(res['httpcode'] == 200){
          this.toastrService.success(`Notified retailer for ${this.retailerInfo.retailerType == 'Prepaid' ? 'balance refund' : 'due payment'} `)
          this.dialogRef.close()
        }
      })
    }
  }
//[disabled]="retailerInfo.paymentStatus == 'Pending Approval'"
checkSubmitDisplayed(){
  if(this.retailerInfo.retailerType.toLowerCase() == 'postpaid'){
    //alert("Hello")
    if(this.retailerInfo.invoiceDue >0 && this.retailerInfo.invoiceDue != null){
      //alert("Hello2")
      return true;
    }else{
      return false;
    }
  }
  if(this.retailerInfo.retailerType.toLowerCase() == 'prepaid'){
     if(this.retailerInfo.currentAmount >0 && this.retailerInfo.currentAmount != null){
      return true; 
    }else{
      return false;
    }
  }            
  return true; 

}
}
